export enum ExplainModalTitleId {
  /** 國內、國外旅遊適用 */
  NTA = 'NTA',
  /** 申根旅遊投保適用 */
  NTAG = 'NTAG',
};
